import {StyleSheet} from 'react-native';

import {fontFamily} from '../Text';

// for the DropDownPicker common to both AddressPicker and SuburbPicker

// SHORTCUT: every colour, type and spacing literal below. Ceiling: frozen -
// DIS-1748 R6 forbids changing any style key SuburbPicker reads, so nothing
// here moves until SuburbPicker migrates too. Upgrade path: colour and
// spacing tokens under app/design-system/tokens/ - DIS-1737 blocks them,
// DIS-1735 is the epic.
const styles = StyleSheet.create({
  placeholderStyle: {
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginBottom: 0,
    fontSize: 20,
    fontWeight: '400',
    fontFamily,
    color: '#BBB',
  },
  pickerStyle: {
    borderColor: 'grey',
    borderWidth: 0.5,
    borderRadius: 4,
  },
  containerStyle: {
    borderRadius: 4,
    paddingTop: 0,
    paddingBottom: 0,
    marginTop: 0,
    marginBottom: 0,
  },
  labelStyle: {
    fontSize: 16,
    fontFamily,
  },
  searchContainerStyle: {
    padding: 0,
    minHeight: 32,
    borderBottomWidth: 0,
  },
  searchTextInputStyle: {
    borderColor: 'grey',
    borderRadius: 4,
    borderWidth: 0.5,
    fontFamily,
    fontSize: 16,
    maxHeight: 32,
    minHeight: 32,
  },
  searchTextInputStyleOpen: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderWidth: 0,
    borderBottomWidth: 1,
  },
  dropDownContainerStyle: {
    borderWidth: 0.5,
    paddingLeft: 0,
    paddingRight: 0,
    borderColor: 'grey',
    borderTopRightRadius: 4,
    borderTopEndRadius: 4,
    borderTopStartRadius: 4,
    position: 'relative',
    zIndex: 500,
  },
  listItemContainerStyle: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  itemSeparatorStyle: {
    borderBottomWidth: 0.5,
    borderColor: 'grey',
  },
  listItemLabelStyle: {
    fontFamily,
  },
  disabledStyle: {
    backgroundColor: 'rgb(243, 243, 243)',
    borderColor: 'rgb(156, 163, 175)',
    color: 'rgb(122, 122, 122)',
    opacity: 0.5,
  },
});

export default styles;
